import React from 'react';
import { ArrowPathIcon, CloudArrowUpIcon, FingerPrintIcon, LockClosedIcon } from '@heroicons/react/24/outline';

const features = [
  {
    name: 'Mental Heath Assessment',
    description:
      'Check your mental wellbeing with a quick and confidential assessment.',
    icon: CloudArrowUpIcon,
  },
  {
    name: 'Write Personal Journals',
    description:
      'Track your mood and thoughts in a secure, private journal for self-reflection.',
    icon: LockClosedIcon,
  },
  
  {
    name: '1:1 Chat with AI Therapist',
    description:
      'Get 24/7 support from an AI therapist to manage your mental health.',
    icon: ArrowPathIcon,
  },
  {
    name: 'Anonymous Chatting',
    description:
      'Connect with a supportive community anonymously and share your experiences.',
    icon: FingerPrintIcon,
  },
]

const Home3 = () => {
    return (
        <div className="relative bg-lightCream">
          
          <div className="relative py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
              <div className="mx-auto max-w-2xl lg:text-center">
                <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                  Unlock your freedom
                </p>
                <p className="mt-6 text-lg leading-8 text-gray-600">
                  A website to keep track of your mental health, write journals, chat anonymously and get a personalized result based
                  on your quiz
                </p>
              </div>
              <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
                <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
                  {features.map((feature) => (
                    <div key={feature.name} className="relative pl-16">
                      <dt className="text-base font-semibold leading-7 text-gray-900">
                        <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-lightLeafGreen">
                          <feature.icon className="h-6 w-6 text-white" aria-hidden="true" />
                        </div>
                        {feature.name}
                      </dt>
                      <dd className="mt-2 text-base leading-7 text-gray-600">{feature.description}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            </div>
          </div>
        </div>
      )
}

export default Home3;
